export default {"src":"/_next/static/media/kayak.095873d8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};